/**
 * apps/battle/client/src/terminal/components/ShortTextInput.tsx
 * Single-line text input for short-text command words (Define, State, Calculate).
 * Enter submits via the parent's keyboard handler. Empty disables submit upstream.
 */
import { useEffect, useRef } from 'react';

interface Props {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  disabled?: boolean;
  /** M10 — when false, paste into the answer field is blocked (anti-paste knob). */
  allowPaste?: boolean;
}

export function ShortTextInput({ value, onChange, onSubmit, disabled, allowPaste = true }: Props) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => { ref.current?.focus(); }, []);
  return (
    <div className="tm-input-line">
      <span className="tm-prompt">{'>'}</span>
      <input
        ref={ref}
        type="text"
        autoComplete="off"
        autoCapitalize="sentences"
        spellCheck={false}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onPaste={allowPaste ? undefined : (e) => e.preventDefault()}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey && value.trim()) {
            e.preventDefault();
            onSubmit();
          }
        }}
      />
    </div>
  );
}
